<div class="flx-modal" role="dialog" aria-modal="true">
  <!-- Section 1: Add New Status -->
  <div class="flx-modal__header w-f3">
    <div class="with-desc">
      <h2>1. {{data?.mode ? translate?.general.buttons.edit.singular : translate?.general.buttons.add.singular + ' ' + translate?.general.buttons.new.singular}} {{translate?.setup.modules.types.sections.sec2.singular}}</h2>
      <div class="sub">{{translate?.setup.modules.types.messages.defineDetailsOfThis}} {{translate?.setup.modules.types.sections.sec2.singular | lowercase}}</div>
    </div>

    <button class="icon-btn" [pTooltip]="translate?.general.buttons.close.singular" (click)="onCancelClick()">
      <i class="fa-regular fa-xmark"></i>
    </button>
  </div>

  <form [formGroup]="statusInfoForm">
    <div class="flx-modal__body skim">
      <div class="status-field">
        <label class="field-label mandatory">{{translate?.setup.modules.types.fields.category.singular}}</label>
        <div class="field-row field-row--auto">
          <p-dropdown
            [placeholder]="translate?.general.buttons.select2.singular + ' ' + translate?.setup.modules.types.fields.category.singular"
            formControlName="statusCategory"
            [filter]="true"
            [showClear]="true"
            optionLabel="label"
            optionValue="name"
            [options]="statusCategories"
          ></p-dropdown>
        </div>
        <span class="hint">{{translate?.setup.modules.types.messages.groupingReportingFiltering}}.</span>
        <div class="p-error text-10" *ngIf="statusInfoForm.get('statusCategory').touched && statusInfoForm.get('statusCategory').invalid">
          <span>{{ translate?.general.validationFE.requiredField }}</span>
        </div>
      </div>
      <div class="status-field">
        <label class="field-label mandatory">{{translate?.setup.modules.types.fields.label.singular}}</label>
        <div class="field-row field-row--auto">
          <input
            pInputText
            formControlName="statusLabel"
            (keyup)="onLabelChange()"
            [placeholder]="translate?.setup.modules.types.messages.enterStatusLabel"
          />
        </div>
        <span class="hint">{{translate?.setup.modules.types.messages.nameShownTo}} {{translate?.setup.users.users.label.plural | lowercase}}.</span>
        <div class="p-error text-10" *ngIf="statusInfoForm.get('statusLabel').touched && statusInfoForm.get('statusLabel').invalid">
          <span>{{ translate?.general.validationFE.requiredField }}</span>
        </div>
      </div>
      <div class="status-field" *ngIf="isCustomerPortalAvailable">
        <label class="field-label mandatory">{{translate?.customer.label.singular}} Portal {{translate?.setup.modules.types.fields.label.singular}}</label>
        <div class="field-row field-row--auto">
          <input
            pInputText
            formControlName="statusLabelPortal"
            [placeholder]="'Enter label for ' + translate?.customer.label.singular + ' portal...'"
          />
        </div>
        <div class="p-error text-10" *ngIf="statusInfoForm.get('statusLabelPortal').touched && statusInfoForm.get('statusLabelPortal').invalid">
          <span>{{ translate?.general.validationFE.requiredField }}</span>
        </div>
      </div>
      <div class="status-field">
        <label class="field-label mandatory">{{translate?.setup.modules.types.fields.code.singular}}</label>
        <div class="field-row field-row--auto">
          <input
            pInputText
            formControlName="statusCode"
            [placeholder]="translate?.setup.modules.types.messages.enterStatusCode"
            [readonly]="true"
          />
        </div>
        <span class="hint">{{translate?.setup.modules.types.messages.shortUniqueIdentifier}}. (e.g., SCHD)</span>
        <div class="p-error text-10" *ngIf="statusInfoForm.get('statusCode').touched && statusInfoForm.get('statusCode').invalid">
          <span>{{ translate?.general.validationFE.requiredField }}</span>
        </div>
      </div>
      <div class="status-field">
        <label class="field-label mandatory">{{translate?.setup.modules.types.fields.color.singular}}</label>
        <div class="field-row field-row--auto_colorpick">
          <input
            pInputText
            placeholder="#FFFFFF"
            formControlName="statusColor"
            maxlength="7" (input)="onColorInputChange()"
          />
          <div class="w-30px">
            <p-colorPicker
              formControlName="defaultColor"
              (onChange)="onColorPickerChange($event)"
            ></p-colorPicker>
          </div>
        </div>
        <div class="p-error text-10" *ngIf="statusInfoForm.get('statusColor').touched && statusInfoForm.get('statusColor').invalid">
          <span *ngIf="statusInfoForm.get('statusColor').errors?.required">{{ translate?.general.validationFE.requiredField }}</span>
          <span *ngIf="statusInfoForm.get('statusColor').errors?.pattern">{{ translate?.general.validationFE.invalid }} {{translate?.setup.modules.types.fields.color.singular}}</span>
        </div>
      </div>
    </div>

    <!-- Section 2: Select Job Types -->
    <div class="flx-modal__header-inline">
      <div class="with-desc">
        <h2>2. {{translate?.setup.modules.types.messages.selectThe}} {{translate?.setup.modules.types.fields.job.singular}} {{translate?.setup.modules.types.fields.type.plural | lowercase}} {{translate?.setup.modules.types.messages.whichWillUseThis}}</h2>
        <div class="sub">{{translate?.setup.modules.types.messages.chooseWhereStatus}}</div>
      </div>
    </div>
    <div class="flx-modal__body">
      <div class="status-field">
        <label class="field-label">{{translate?.setup.modules.types.messages.addStatusTo}} {{translate?.setup.modules.types.fields.job.singular}} {{translate?.setup.modules.types.fields.type.plural | lowercase}}</label>
        <div class="field-row field-row--auto_colorpick">
          <p-dropdown
            class="w-100"
            [options]="jobOrderTypes"
            [placeholder]="translate?.general.buttons.select2.singular + ' ' + translate?.setup.modules.types.fields.job.singular + ' ' + translate?.setup.modules.types.fields.type.plural"
            formControlName="jobType"
            optionLabel="name"
            [filter]="true"
            optionValue="id"
            (onChange)="onAddJOType()"
          ></p-dropdown>
        </div>
        <span class="hint">{{translate?.setup.modules.types.messages.thisStatusSelectable}} {{translate?.setup.modules.types.fields.type.plural | lowercase}} {{translate?.setup.modules.types.messages.youInclude}}.</span>
      </div>

      <div class="status-chip-row" *ngIf="jobTypeAssignments?.length > 0">
        <div class="status-chip status-chip--profile" *ngFor="let jt of jobTypeAssignmentsSpliced; index as i">
          <span class="status-chip__text">{{ jt?.name }}</span>
          <button type="button" [hidden]="jt?.id == data?.joTypeId && !data?.mode" class="status-chip__remove" (click)="removeJobType(jt, i)">
            <i class="fa-regular fa-xmark"></i>
          </button>
        </div>

        <button type="button" (click)="onShowMoreToggle('jobType')" class="status-chip-row__toggle" *ngIf="jobTypeAssignments?.length > 10">
          {{ showAllJobTypes ? translate?.general.buttons.showLess.singular : translate?.general.buttons.showMore.singular }}
          <i class="fa-regular fa-circle-ellipsis" *ngIf="!showAllJobTypes"></i>
          <i class="fa-regular fa-circle-chevron-up" *ngIf="showAllJobTypes"></i>
        </button>
      </div>
    </div>

    <!-- Section 3: Select Profiles -->
    <div class="flx-modal__header-inline">
      <div class="with-desc">
        <h2>3. {{translate?.setup.modules.types.messages.selectWhoCanUseStatus}}</h2>
        <div class="sub">{{translate?.setup.modules.types.messages.whoCanSetStatus}} {{translate?.setup.modules.types.fields.job.singular | lowercase}}?</div>
      </div>
    </div>
    <div class="flx-modal__body">
      <div class="status-field">
        <label class="field-label">{{translate?.setup.modules.types.fields.whichProfilesCanUse.singular}}</label>
        <div class="field-row field-row--auto_colorpick">
          <p-dropdown
            class="w-100"
            [options]="profiles"
            [placeholder]="translate?.general.buttons.select2.singular + ' ' + translate?.profile.label.plural"
            formControlName="profiles"
            optionLabel="name"
            [filter]="true"
            optionValue="id"
            (onChange)="onAddProfile()"
          ></p-dropdown>
        </div>
        <span class="hint">{{translate?.setup.modules.types.messages.selectedProfilesCan}}.</span>
      </div>

      <div class="status-chip-row" *ngIf="profileAssignments?.length">
        <div class="status-chip status-chip--profile" *ngFor="let pa of profileAssignmentsSpliced; index as i">
          <span class="status-chip__text">{{ pa?.name }}</span>
          <button type="button" class="status-chip__remove" (click)="removeProfile(pa, i)">
            <i class="fa-regular fa-xmark"></i>
          </button>
        </div>

        <button *ngIf="profileAssignments?.length > 10" type="button" class="status-chip-row__toggle" (click)="onShowMoreToggle('profile')">
          {{ showAllProfiles ? translate?.general.buttons.showLess.singular : translate?.general.buttons.showMore.singular }}
          <i class="fa-regular fa-circle-ellipsis" *ngIf="!showAllProfiles"></i>
          <i class="fa-regular fa-circle-chevron-up" *ngIf="showAllProfiles"></i>
        </button>
      </div>
    </div>
  </form>

  <div class="flx-modal__footer">
    <button type="button" class="custella-btn-white" (click)="onCancelClick()">
      {{ translate?.general.buttons.cancel.singular }}
    </button>
    <p-button
      styleClass="h-32"
      type="button"
      [label]="translate?.general.buttons.confirm.singular"
      (onClick)="onFormSubmit()"
    ></p-button>
  </div>
</div>